import { useId } from "react";

import { cn } from "@/lib/utils";

export default function ThiefHeroIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-[812px] w-[375px]", className)}
      fill="none"
      preserveAspectRatio="xMidYMid slice"
      viewBox="0 0 375 812"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${id}-a)`}>
        <path d="M0 0h375v812H0z" fill="#fff" />
        <path d="M-3902.5 0H2149v737.145h-6051.5z" fill={`url(#${id}-b)`} />
        <g filter={`url(#${id}-c)`}>
          <ellipse
            cx="-495.52"
            cy="218.475"
            fill="#4994D7"
            rx="572.347"
            ry="572.237"
          />
        </g>
        <g filter={`url(#${id}-d)`}>
          <ellipse
            cx="512.732"
            cy="218.475"
            fill="#4994D7"
            rx="572.347"
            ry="572.237"
          />
        </g>
        <path
          d="M361.639 380.229v200.025h-78.027V412.557h18.36v-32.328h59.667z"
          fill={`url(#${id}-e)`}
        />
        <path
          d="M158.379 309.515v272.759h87.206V309.515h-22.031v-33.337h-12.851l-8.262-43.44h-8.261l-8.262 43.44h-11.015v33.337h-16.524z"
          fill={`url(#${id}-f)`}
        />
        <path
          d="M110.779 442.286v140.998H17.87V442.286h19.533l10.778-34.864h32.331l11.942 34.864h18.325z"
          fill={`url(#${id}-g)`}
        />
        <path
          clipRule="evenodd"
          d="M-1082.48 225.361l401.669-1.823 697.137-3.177 49.774-.222 38.184-.394 90.133-.912c-14.449-4.483-37.274-9.878-64.061-12.489-34.806-3.399-76.334-2.118-114.94 12.021-.162-.172-.324-.345-.519-.492-6.136-6.06-12.565-10.888-19.124-14.706-48.995-28.723-105.718-1.552-113.056 2.192-.552.271-.812.419-.812.419s.065-.468.162-1.355c.163-1.33.358-3.572.423-6.429.097-4.434-.065-10.346-1.104-16.628-2.403-13.795-9.189-29.387-27.177-34.881-28.183-8.621-55.521 21.308-70.003 41.089-6.656 9.114-10.584 16.085-10.584 16.085s0-3.375-1.396-8.695c-4.708-18.081-43.295-88.854-145.938-88.854-102.643 0-127.72 62.383-165.178 110.851l-51.691-11.183-2.142-.444c-52.243-10.321-150.201 5.346-150.201 5.346s-18.604-18.796-71.561-21.086c-52.957-2.316-129.128 29.239-129.128 29.239-72.507-3.744-138.867 6.528-138.867 6.528z"
          fill="#fff"
          fillRule="evenodd"
          opacity="0.5"
          style={{ mixBlendMode: "soft-light" }}
        />
        <path
          d="M-500.297 878.833c98.869-28.248 45.862 43.868 0 0-41.842-40.023 165.865 11.818 0 0-61.384-4.374 11.445 2.693 0 0-26.576-6.253-343.556-266.364-519.303-302.661h423.205s355.759-25.782 1221.891 14.35C1491.63 630.654 2589.15 1013.4 2589.15 1013.4V852.353l-3025.916 32.542-63.531-6.062z"
          fill={`url(#${id}-h)`}
        />
        <path
          d="M-60.467-45.728L870.97 166.686v9.136L-60.467 242.99V-45.73z"
          fill={`url(#${id}-i)`}
        />
        <path
          d="M-991.786 876.471c62.438-28.744 28.963 44.638 0 0-26.424-40.725 104.747 12.026 0 0-38.764-4.45 7.228 2.741 0 0-16.784-6.363-216.964-271.039-327.954-307.972l29.05-17.041s873.311-9.194 1420.292 31.642c546.982 40.837 1711.428 430.3 1711.428 430.3l-691.76-163.874-2100.935 33.113-40.121-6.168z"
          fill="#4E4288"
        />
        <path
          clipRule="evenodd"
          d="M-489.126 556.583a1 1 0 00.975 1.224c525.28 0 1164.415 178.901 1390.104 257.924a1 1 0 00.661-1.888C698.916 742.521 158.551 589.857-331.184 560.681a19054.658 19054.658 0 00-157.942-4.098zm190.584 5.118c22.077.711 44.104 1.466 66.029 2.267 476.387 35.883 988.156 180.908 1185.127 249.875a1 1 0 01-.661 1.888c-206.016-72.135-756.541-227.494-1250.495-254.03z"
          fill="#F1953E"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M638.647 857.574l-33.973-8.048-1599.062 25.203c-7.112-5.883-23.962-25.284-46.932-51.719-70.3-80.906-197.86-227.703-278.42-254.511l27.5-16.135c279.61 3.124 615.726 11.212 877.248 30.736 310.998 23.219 821.606 159.14 1204.302 272.1l-150.663 2.374z"
          fill="#4E6EC0"
          fillRule="evenodd"
        />
        <path
          d="M467.07 746.328c0 5.583-52.632 10.109-117.557 10.109-64.925 0-117.557-4.526-117.557-10.109s52.632-10.109 117.557-10.109c64.925 0 117.557 4.526 117.557 10.109z"
          fill={`url(#${id}-j)`}
          opacity="0.8"
          style={{ mixBlendMode: "multiply" }}
        />
        <ellipse
          cx="232.392"
          cy="687.647"
          fill={`url(#${id}-k)`}
          rx="258.372"
          ry="23.613"
          style={{ mixBlendMode: "multiply" }}
        />
        <ellipse
          cx="49.589"
          cy="658.354"
          fill="#292151"
          rx="29.63"
          ry="33.992"
        />
        <ellipse
          cx="205.602"
          cy="654.628"
          fill="#292151"
          rx="31.193"
          ry="30.683"
        />
        <path
          d="M311.719 672.114c0 17.858-22.519 18.819-32.717 17.101-13.262-2.235-24.352-14.477-24.352-32.335s10.903-32.335 24.352-32.335 32.717 29.711 32.717 47.569zm-181.748-10.403c0 20.769 12.343 41.115-28.322 37.606-15.583-1.345-28.32-16.837-28.32-37.606 0-20.769 12.679-37.606 28.32-37.606 15.642 0 28.322 16.837 28.322 37.606z"
          fill="#292151"
        />
        <path
          clipRule="evenodd"
          d="M343.982 660.574V537.666l-181.749-4.554-67.126 6.624-14.434 45.541-45.917 13.281a21.523 21.523 0 00-15.502 19.335l-.475 7.616c-2.67 2.638-5.614 8.081-4.611 17.071h3.546l-.608 9.743v12.751l130.824 3.536 196.052-8.036z"
          fill={`url(#${id}-l)`}
          fillRule="evenodd"
        />
        <path
          d="M274.672 558.013c10.554 1.208 18.238-4.557 21.646-8.691a1.15 1.15 0 011.756 0c3.407 4.134 11.092 9.899 21.646 8.691 1.022-.117 2.07 1.516 1.645 2.453-.957 2.112-1.625 5.035-1.001 8.501 1.328 7.378 7.086 18.446 2.659 26.562-3.514 6.443-18.415 15.644-25.827 19.773-7.329-4.082-22.286-13.281-25.827-19.773-4.427-8.116 1.331-19.184 2.659-26.562.624-3.466-.044-6.389-1.001-8.501-.425-.937.623-2.57 1.645-2.453z"
          fill="#9AAAF1"
        />
        <path
          d="M280.402 563.254c7.629.55 13.235-3.532 15.901-6.633a1.195 1.195 0 011.784 0c2.666 3.101 8.273 7.183 15.902 6.633 1.026-.074 2.152 1.643 1.801 2.61-.568 1.565-.887 3.569-.471 5.882 1.039 5.772 5.544 14.43 2.081 20.779-2.749 5.04-14.406 12.238-20.205 15.468-5.733-3.193-17.434-10.389-20.204-15.468-3.463-6.349 1.042-15.007 2.08-20.779.417-2.313.097-4.317-.47-5.882-.351-.967.775-2.684 1.801-2.61z"
          stroke="#768BF3"
          strokeLinecap="round"
          strokeWidth="3"
        />
        <path
          clipRule="evenodd"
          d="M165.468 533.193l-17.025 54.413c-23.995 4.352-89.731 31.019-89.731 55.796h-41.05l.052-.822h-3.546c-1.003-8.99 1.942-14.433 4.611-17.071l.475-7.616a21.523 21.523 0 0115.502-19.335l45.917-13.281 14.434-45.541 67.126-6.624 3.235.081z"
          fill={`url(#${id}-m)`}
          fillRule="evenodd"
        />
        <path
          d="M71.523 630.853c-1.624.515-3.279 2.552-4.567 4.528-.988 1.515.176 3.438 1.985 3.438h13.224c.894 0 1.767-.322 2.37-.982 1.861-2.043 3.957-5.35 2.836-7.481-1.66-3.153-12.446-.581-15.848.497z"
          fill="#fff"
        />
        <path
          clipRule="evenodd"
          d="M13.969 638.819h3.152c1.81 0 2.973-1.923 1.985-3.438-1.096-1.682-2.458-3.407-3.84-4.201-.759 2.075-1.27 4.607-1.297 7.639z"
          fill="#fff"
          fillRule="evenodd"
        />
        <circle cx="256.533" cy="548.41" fill="#fff" r="1.883" />
        <circle cx="256.533" cy="586.749" fill="#733070" r="1.883" />
        <circle cx="256.533" cy="635.544" fill="#fff" r="1.883" />
        <circle cx="337.859" cy="549.53" fill="#fff" r="1.883" />
        <circle cx="337.859" cy="584.383" fill="#fff" r="1.883" />
        <circle cx="337.859" cy="630.855" fill="#fff" r="1.883" />
        <path
          d="M166.06 551.363l33.781.643-.669 83.948-39.998.819-5.594-10.571 1.174-37.719 11.306-37.12zm40.572.689l34.943.662-.302 107.482-34.392.739-.249-108.883z"
          stroke="#374DB3"
          strokeLinecap="round"
          strokeWidth="1.905"
        />
        <ellipse
          cx="115.172"
          cy="661.711"
          fill={`url(#${id}-n)`}
          rx="28.321"
          ry="37.606"
        />
        <path
          d="M150.176 668.805c0-32.079-8.371-58.085-48.766-58.085-26.932 0-48.765 26.006-48.765 58.085"
          stroke="#374DB3"
          strokeWidth="1.905"
        />
        <path
          d="M156.205 557.557h2.106a2.87 2.87 0 012.87 2.869v31.489a2.87 2.87 0 01-2.87 2.869h-2.106"
          stroke="#374DB3"
          strokeLinecap="round"
          strokeWidth="2.858"
        />
        <path
          d="M166.745 563.377l-4.293 20.233a2.87 2.87 0 002.758 3.465l28.19.477a1.434 1.434 0 001.459-1.41l.393-23.169a1.436 1.436 0 00-1.41-1.459l-24.241-.41a2.869 2.869 0 00-2.856 2.273z"
          fill="#372B76"
        />
        <rect
          fill="#fff"
          height="26.168"
          rx="4.305"
          width="10.312"
          x="157.662"
          y="562.275"
        />
        <path
          d="M8.352 642.215c2.114.264 58.495 1.54 86.072 2.297l-2.55 24.67c-.148 1.445-1.331 2.547-2.783 2.545-13.12-.02-57.68-1.036-76.991-4.144-2.355-.379-4.304-2.028-4.786-4.363-1.713-8.292-1.229-21.288 1.038-21.005z"
          fill="#fff"
        />
        <path
          d="M215.74 567.272l-.181 10.702a2.87 2.87 0 002.821 2.918l11.966.203a2.87 2.87 0 002.918-2.821l.181-10.702a2.87 2.87 0 00-2.821-2.918l-11.966-.202a2.87 2.87 0 00-2.918 2.82zm-36.098 81.734v3.915a2.87 2.87 0 002.869 2.87h11.968a2.87 2.87 0 002.87-2.87v-4.7a2.87 2.87 0 00-3.058-2.864l-11.967.786a2.87 2.87 0 00-2.682 2.863zm49.135-46.19l-.124 7.34a1.434 1.434 0 001.41 1.459l1.201.021a1.436 1.436 0 001.459-1.411l.124-7.34a1.435 1.435 0 00-1.41-1.459l-1.201-.02a1.435 1.435 0 00-1.459 1.41zm-37.985-.322l-.124 7.341a1.435 1.435 0 001.41 1.459l1.2.02a1.434 1.434 0 001.459-1.41l.125-7.341a1.436 1.436 0 00-1.411-1.459l-1.2-.02a1.435 1.435 0 00-1.459 1.41z"
          fill="#413776"
        />
        <ellipse
          cx="116.714"
          cy="662.492"
          fill="#91A1E9"
          rx="15.301"
          ry="20.318"
        />
        <ellipse
          cx="116.715"
          cy="662.492"
          fill="#413776"
          rx="5.922"
          ry="7.863"
        />
        <path
          d="M146.433 577.234l12.665-39.393-61.55 5.295-10.913 34.342a2.87 2.87 0 002.734 3.739h51.6a5.739 5.739 0 005.464-3.983z"
          fill="#372B76"
        />
        <path
          clipRule="evenodd"
          d="M122.735 581.217l-27.386-31.158 2.2-6.923 4.672-.402 42.558 37.036a5.73 5.73 0 01-3.81 1.447h-18.234z"
          fill={`url(#${id}-o)`}
          fillRule="evenodd"
        />
        <path
          d="M49.383 606.659c-2.451-1.501-10.721-1.344-17.24-.77-3.924.345-7.133 3.016-7.797 6.899-1.042 6.091-1.726 14.702-1.709 21.571.007 2.807 2.203 5.052 5.001 5.26 7.31.545 20.566 1.271 23.005-.402 3.401-2.333 2.126-30.483-1.26-32.558z"
          fill="#606CBB"
        />
        <path
          clipRule="evenodd"
          d="M29.401 606.551a8.634 8.634 0 00-2 1.151v31.895c.079.009.158.017.238.023.555.041 1.145.084 1.762.126v-33.195zm5.668 33.525a273.01 273.01 0 01-2-.102v-34.163c.656-.052 1.325-.1 2-.142v34.407zm5.668.172a137.73 137.73 0 01-2-.037v-34.705a75.261 75.261 0 012-.027v34.769zm5.668-.132c-.625.046-1.295.08-2 .102v-34.626a27.91 27.91 0 012 .208v34.316z"
          fill="#4F4F96"
          fillRule="evenodd"
        />
        <path
          d="M80.635 585.179h56.84c5.547 0 10.044 4.497 10.044 10.044v46.45"
          stroke="#374DB3"
          strokeLinecap="round"
          strokeWidth="1.905"
        />
        <ellipse
          cx="294.105"
          cy="656.44"
          fill={`url(#${id}-p)`}
          rx="24.351"
          ry="32.335"
        />
        <ellipse
          cx="296.316"
          cy="656.07"
          fill="#91A1E9"
          rx="13.237"
          ry="17.577"
        />
        <ellipse
          cx="296.316"
          cy="656.07"
          fill="#413776"
          rx="4.215"
          ry="5.597"
        />
        <path
          d="M324.435 664.747v-20.595h23.291v19.596l-23.291.999z"
          fill="#fff"
        />
        <path
          d="M289.082 601.716c-.835 7.912-6.731 13.537-14.348 12.734-7.617-.804-13.115-7.869-12.281-15.781.834-7.912 7.686-13.675 15.302-12.872 7.617.803 12.161 8.007 11.327 15.919z"
          fill="#733070"
        />
        <path
          d="M288.109 581.327c-6.11.03-8.029 6.136-8.224 9.186l.99.66c1.584-1.721 5.8-3.712 9.993 2.094 4.194 5.805 10.291 4.723 12.815 3.457-5.993 1.067-7.935-15.434-15.574-15.397z"
          fill="#733070"
        />
        <path
          d="M338.259 713.096c-17.646-8.366-9.426-36.403-8.554-45.008.115-2.484-.092-6.765 1.385-6.493 2.777 4.085 30.227 14.084 39.2 26.256 8.973 12.171-9.973 35.702-32.031 25.245z"
          fill="#FFA670"
        />
        <path
          clipRule="evenodd"
          d="M336.119 665.151c1.745.981 3.83 2.077 6.11 3.275 9.52 5.003 22.429 11.786 28.061 19.425 6.327 8.583-1.228 22.814-13.968 26.793 2.727-3.613 6.131-10.166 4.243-16.099-1.332-4.188-3.221-5.502-4.808-6.606-1.672-1.162-3.009-2.092-3.009-5.901 0-5.711-10.402-15.814-16.629-20.887z"
          fill="#E3854C"
          fillRule="evenodd"
        />
        <path
          d="M311.184 740.637l-1.505-5.119 5.921-2.008 1.707 5.621-6.123 1.506zm-28.967 3.518l-.129-5.334 6.239-.406.194 5.871-6.304-.131z"
          fill="#F3898A"
        />
        <path
          d="M266.904 696.104l9.688-33.575h30.217c-.711 6.517-5.727 26.612-8.147 35.845l19.316 36.22-10.28 2.144-21.357-31.315a12.37 12.37 0 01-1.988-8.968l3.003-18.36-7.061 23.242 10.416 38.067h-10.416l-13.113-35.592a12.377 12.377 0 01-.278-7.708z"
          fill="#CCDAFF"
        />
        <path
          clipRule="evenodd"
          d="M306.189 666.476c-8.726 3.962-23.27-.34-29.797-3.165l3.263-.782h27.155c-.111 1.016-.327 2.363-.621 3.947zm-18.994 12.151l.122-.459-1.457-6.941-5.412 29.61 6.747-22.21zm-6.863 22.842l.055.201-.099.04.044-.241z"
          fill="#A2B4E4"
          fillRule="evenodd"
        />
        <path
          d="M317.037 736.883l3.143 8.618-20.583 7.605c-.676-.068-1.805-1.197-.913-5.171.892-3.975 6.794-4.631 9.633-4.462l2.028-5.069 6.692-1.521zm-28.194 5.161l.805 9.138-21.85 2.019c-.636-.241-1.434-1.623.457-5.232 1.89-3.608 7.76-2.714 10.459-1.816l3.271-4.372 6.858.263z"
          fill="#4D0D54"
        />
        <path
          d="M332.013 661.593c.04-.512-2.317-3.304-3.501-4.635l-5.129 1.627v4.833c0 1.233 1.134 1.036 1.183 1.578.05.543 1.085 2.91 3.107 3.009 2.022.098 4.291-5.77 4.34-6.412z"
          fill="#F3898A"
        />
        <path
          d="M224.742 633.049c1.653-1.938 5.439-5.028 7.354-1.881 1.915 3.147 4.903 23.43 6.157 33.179"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="2.18"
        />
        <path
          d="M239.712 649.176c.319.19.996.671 1.295 1.656l1.295 3.973c-1.61.079-5.319.19-7.271 0-2.44-.237-2.639-4.445-2.639-5.629 0-1.185 1.792-1.185 1.792-1.718 0-.533 2.739-.533 3.835-.533s1.295 2.014 1.693 2.251z"
          fill="#F3898A"
        />
        <path
          d="M320.123 657.876c.955 0 3.103 1.591 4.057 2.386 1.401.382 1.698 1.91 1.671 2.626-1.973 1.018-4.322 3.341-5.251 4.375-1.007-1.06-3.023-3.421-3.023-4.375 0-.955 1.697-1.247 2.546-1.273-.398-1.247-.955-3.739 0-3.739z"
          fill="#FFA670"
        />
        <path
          d="M275.263 617.52l5.999-2.907 4.474-1.427a16.5 16.5 0 0115.678 3.131l12.86 10.897a24.751 24.751 0 017.027 9.813l7.837 19.905-6.352 2.524-10.022-20.724-11.256-7.923c6.422 10.225 6.003 23.744 5.253 31.561-8.878 6.08-24.686 2.015-30.283 1.014 1.06-8.803-1.945-17.891-2.26-24.205l-3.314 11.308a5.892 5.892 0 01-5.463 4.232l-23.928.774c-.416-.379-.69-3.701-.776-5.088l22.418-3.909 2.702-16.382a17.088 17.088 0 019.406-12.594z"
          fill="#4D0D54"
        />
        <path
          clipRule="evenodd"
          d="M305.089 619.431l-3.675-3.114a16.473 16.473 0 00-2.289-1.627c-2.331.506-4.659.93-6.975 1.275a104.465 104.465 0 01-16.054 1.152l-.832.404a17.065 17.065 0 00-6.344 5.296c7.628.595 15.813.318 24.113-.918a113.77 113.77 0 0012.056-2.468zm-40.099 15.947l.868-5.264c.036-.22.077-.44.122-.658 8.274 1.084 17.6 1.038 27.268-.401a107.075 107.075 0 0018.096-4.324l2.93 2.484a24.59 24.59 0 012.174 2.082 111.231 111.231 0 01-11.912 3.643l-3.028-2.13a29.94 29.94 0 011.415 2.514 113.935 113.935 0 01-8.792 1.665c-10.155 1.512-20.139 1.588-29.141.389zm-5.972 11.84l4.137-.722.732-4.433c2.918.503 5.988.859 9.177 1.056l-1.727 5.894c-4.309-.326-8.442-.93-12.319-1.795zm-16.323 2.846l7.183-1.253c4.85 2.498 10.869 4.371 17.647 5.455a5.897 5.897 0 01-2.084.453l-16.047.519a45.884 45.884 0 01-5.285-2.801 2.996 2.996 0 01-1.414-2.373zm64.374 8.16a109.777 109.777 0 01-10.133 1.971c-6.93 1.014-13.773 1.335-20.275 1.025.1-2.015.018-4.033-.167-6.015 6.19.327 12.797.044 19.574-.947a103.97 103.97 0 0011.068-2.237 74.53 74.53 0 01-.067 6.203zm19.841-6.952a103.244 103.244 0 01-6.703 2.849l-2.622-5.421a97.583 97.583 0 007.122-3.023l2.203 5.595zm-6.599-16.441c.365.714.695 1.447.991 2.197l1.315 3.342a108.114 108.114 0 01-7.644 2.929l-2.208-4.567-.984-.693a102.238 102.238 0 008.53-3.208zm-14.895 5.067c-3.695.954-7.399 1.7-11.07 2.246-6.813 1.015-13.456 1.337-19.681 1.06.176 1.152.386 2.358.603 3.607.138.795.28 1.608.417 2.435 6.288.199 12.88-.175 19.545-1.167a113.597 113.597 0 0011.384-2.295 46.5 46.5 0 00-1.198-5.886z"
          fill="#7469A3"
          fillRule="evenodd"
        />
        <circle cx="280.29" cy="617.038" fill="#CE5E60" r="4.648" />
        <ellipse
          cx="287.088"
          cy="605.508"
          fill="#CE5E60"
          rx="1.978"
          ry="3.294"
          transform="rotate(10.913 287.088 605.508)"
        />
        <path
          d="M263.144 601.64l19.578-7.284 2.532 7.479c2.554 7.541-1.488 15.724-9.029 18.278a6.246 6.246 0 01-7.892-3.83l-5.189-14.643z"
          fill="#F3898A"
        />
        <path
          d="M271.41 610.157c-.237.559-.709 1.855-.709 2.576 0 .722.773.988 1.159 1.031m3.94 2.178c.751.018 2.399-.293 2.986-1.676"
          stroke="#CE5E60"
          strokeLinecap="round"
        />
        <path
          d="M265.683 611.676c-1.239-1.913-1.789-5.799-1.916-7.354l22.939-3.576v3.257s-1.143 4.531-4.499 6.072c-2.492 1.144-5.698.767-8.614.365-1.867-.257-3.745.205-5.313 1.249l-.237.157c-.793.528-1.842.629-2.36-.17z"
          fill="#4D0D54"
        />
        <ellipse
          cx="267.019"
          cy="607.882"
          fill="#fff"
          rx="0.635"
          ry="1.319"
          transform="rotate(-8.188 267.019 607.882)"
        />
        <ellipse
          cx="275.644"
          cy="606.667"
          fill="#fff"
          rx="0.635"
          ry="1.319"
          transform="rotate(-8.188 275.644 606.667)"
        />
        <path
          d="M269.595 599.847c-2.584 8.032-4.959 7.896-7.446 7.407-5.138-10.748 9.14-16.118 19.473-16.118l5.136 6.848.561 1.863-1.058 8.027c-.733-2.527-1.724-5.286-6.469-6.324-4.744-1.038-8.607-1.05-10.197-1.703z"
          fill="#733070"
        />
        <path d="M0 0h375v616H0V0z" fill={`url(#${id}-q)`} opacity="0.5" />
      </g>
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-b`}
          x1="-876.749"
          x2="-876.749"
          y1="26.885"
          y2="867.486"
        >
          <stop stopColor="#FF9877" />
          <stop offset="1" stopColor="#FFC6B5" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-e`}
          x1="322.626"
          x2="322.626"
          y1="270.051"
          y2="580.254"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#4D0D54" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-f`}
          x1="201.982"
          x2="201.982"
          y1="135.307"
          y2="582.274"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#4D0D54" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-g`}
          x1="64.324"
          x2="64.324"
          y1="310.553"
          y2="583.284"
        >
          <stop stopColor="#4D0D54" />
          <stop offset="1" stopColor="#4D0D54" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-h`}
          x1="849.523"
          x2="849.523"
          y1="545.002"
          y2="884.895"
        >
          <stop stopColor="#FF9860" />
          <stop offset="1" stopColor="#FFE2B7" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-i`}
          x1="1139.23"
          x2="174.539"
          y1="186.504"
          y2="549.068"
        >
          <stop stopColor="#FFBB68" />
          <stop offset="1" stopColor="#FFD168" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-j`}
          x1="543.806"
          x2="83.83"
          y1="763.676"
          y2="693.248"
        >
          <stop stopColor="#0E4D89" stopOpacity="0" />
          <stop offset="1" stopColor="#89460E" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-k`}
          x1="911.146"
          x2="-1111.09"
          y1="781.849"
          y2="604.277"
        >
          <stop stopColor="#0E4D89" stopOpacity="0" />
          <stop offset="1" stopColor="#89460E" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-l`}
          x1="178.975"
          x2="508.424"
          y1="559.764"
          y2="763.199"
        >
          <stop stopColor="#576FEF" />
          <stop offset="1" stopColor="#A5B6FA" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-m`}
          x1="157.619"
          x2="59.434"
          y1="634.037"
          y2="583.521"
        >
          <stop stopColor="#7584D2" />
          <stop offset="1" stopColor="#A5B6FA" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-n`}
          x1="115.172"
          x2="115.172"
          y1="648.345"
          y2="705.74"
        >
          <stop stopColor="#413776" />
          <stop offset="1" stopColor="#687BCF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-o`}
          x1="120.598"
          x2="120.598"
          y1="539.521"
          y2="584.805"
        >
          <stop stopColor="#8A7FC7" />
          <stop offset="1" stopColor="#413776" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-p`}
          x1="294.105"
          x2="294.105"
          y1="644.947"
          y2="694.297"
        >
          <stop stopColor="#413776" />
          <stop offset="1" stopColor="#687BCF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-q`}
          x1="187.5"
          x2="187.5"
          y1="187.22"
          y2="616"
        >
          <stop />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="2622.38"
          id={`${id}-c`}
          width="2622.6"
          x="-1806.82"
          y="-1092.72"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_6284_34378"
            stdDeviation="369.477"
          />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="2944.47"
          id={`${id}-d`}
          width="2944.69"
          x="-959.615"
          y="-1253.76"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_6284_34378"
            stdDeviation="450"
          />
        </filter>
        <clipPath id={`${id}-a`}>
          <path d="M0 0h375v812H0z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
}
